import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '.';

export const reducers = {
  getStemExtensionsData(state) {
    state.isLoading = true;
  },
  getStemExtensionsDataSuccess(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  getStemExtensionsDataFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
  setStemExtensionsData(state) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = null;
  },
};
